export let TypeAnalytics;

(function (TypeAnalytics) {
  TypeAnalytics["ReqAnalyticsLogEvent"] = "REQ.ANALYTICS.LOG_EVENT";
})(TypeAnalytics || (TypeAnalytics = {}));